import React from 'react';
import { Tooltip } from '@material-ui/core';
import {
  getGridSingleSelectOperators,
  GridCellParams,
  GridColDef,
  GridValueFormatterParams,
  GridValueGetterParams,
} from '@mui/x-data-grid-pro';
import { CompraVendaResumoResponse, OperacaoOfertaPrimariaResponse } from 'common/genericTypes';
import {
  obterTextoDocumento,
  obterTextoDocumentoExportado,
  obterValorSelecaoDocumento,
  TEXTO_POSSUI_DOCUMENTO,
  TEXTO_SEM_DOCUMENTO,
  VALOR_SELECAO_POSSUI_DOCUMENTO,
  VALOR_SELECAO_SEM_DOCUMENTO,
} from 'pages/operacoes/gerenciar/colunasRelatorioMovimentacao';

const COR_POSSUI_DOCUMENTO = '#4caf50';
const COR_SEM_DOCUMENTO = '#d1c4e9';

interface IndicadorDeDocumentoProps {
  possuiDocumento: boolean;
}

const IndicadorDeDocumento: React.FC<IndicadorDeDocumentoProps> = ({ possuiDocumento }) => {
  const descricao = obterTextoDocumento(possuiDocumento);

  return (
    <Tooltip title={descricao} aria-label={descricao}>
      <span style={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
        <span
          style={{
            display: 'inline-block',
            width: 16,
            height: 16,
            borderRadius: '50%',
            backgroundColor: possuiDocumento ? COR_POSSUI_DOCUMENTO : COR_SEM_DOCUMENTO,
          }}
        />
      </span>
    </Tooltip>
  );
};

export const colunaDocumentoOfertaPrimaria: GridColDef = {
  field: 'comprovante',
  headerName: 'Documento',
  filterable: false,
  sortable: false,
  disableExport: false,
  width: 130,
  minWidth: 130,
  maxWidth: 180,
  valueGetter: (params: GridValueGetterParams): string =>
    obterTextoDocumentoExportado((params.row as OperacaoOfertaPrimariaResponse).hasDocument),
  renderCell: (params: GridCellParams) => (
    <IndicadorDeDocumento possuiDocumento={(params.row as OperacaoOfertaPrimariaResponse).hasDocument === true} />
  ),
};

export const colunaDocumentoCompraVenda: GridColDef = {
  field: 'HAS_DOCUMENT',
  headerName: 'Documento',
  type: 'singleSelect',
  valueOptions: [
    { value: VALOR_SELECAO_POSSUI_DOCUMENTO, label: TEXTO_POSSUI_DOCUMENTO },
    { value: VALOR_SELECAO_SEM_DOCUMENTO, label: TEXTO_SEM_DOCUMENTO },
  ],
  filterOperators: getGridSingleSelectOperators().filter(({ value }) => ['is'].includes(value)),
  filterable: true,
  sortable: true,
  disableExport: false,
  width: 110,
  minWidth: 100,
  maxWidth: 150,
  valueGetter: (params: GridValueGetterParams): string =>
    obterValorSelecaoDocumento((params.row as CompraVendaResumoResponse).hasComprovantes),
  valueFormatter: (params: GridValueFormatterParams): string =>
    obterTextoDocumentoExportado(params.value === VALOR_SELECAO_POSSUI_DOCUMENTO),
  renderCell: (params: GridCellParams) => (
    <IndicadorDeDocumento possuiDocumento={(params.row as CompraVendaResumoResponse).hasComprovantes === true} />
  ),
};
